import * as React from 'react';
import { Helmet } from 'react-helmet';
import { PAGE_NAMES } from '@webapp/store/analytics/effects/track-location-change';
import { matchPath, useLocation } from 'react-router';

const DEFAULT_TITLE = 'trac.co';

export default function PageTitle() {
  const { pathname } = useLocation();
  const [title, setTitle] = React.useState(DEFAULT_TITLE);

  React.useEffect(() => {
    const getTitle = (path?: string) => {
      const pageTitle = path
        ? PAGE_NAMES.find((route) => matchPath(path, route.path))?.name
        : null;
      return pageTitle ? `${DEFAULT_TITLE} | ${pageTitle}` : DEFAULT_TITLE;
    };
    setTitle(getTitle(pathname));
  }, [pathname]);

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
}
